import React from 'react'
import {
  string, bool, object,
} from 'prop-types'

function InputField({
  showError = false,
  errorText = null,
  availabilityNotification = { message: null, type: 'notification' },
  label = '',
  id = '',
  required = false,
  moreInfo,
  customClass,
  ...rest
}) {
  const showAvailability = availabilityNotification.message && !errorText
  const inputErrorClass = [
    showError && errorText ? 'cgt-input--error' : '',
    showAvailability && availabilityNotification.type === 'notification' ? 'cgt-input--success' : '',
    showAvailability && availabilityNotification.type === 'error' ? 'cgt-input--error' : '',
  ].join(' ')

  const inputClass = customClass ? `cgt-input ${customClass}` : 'cgt-input'

  return (
    <div className={`${inputClass} ${inputErrorClass}`}>
      {label !== '' && (
        <label htmlFor={id}>
          {label}
          {required
            && <b> *</b>}
        </label>
      )}

      <div className="cgt-input__field-wrap">
        <input
          id={id}
          {...rest}
        />

        {showError && (
          <div className="cgt-input__error-message">
            {errorText}
          </div>
        )}
        {showAvailability && (
          <div
            className={availabilityNotification.type === 'notification' ? 'cgt-input__success-message' : 'cgt-input__error-message'}
          >
            {availabilityNotification.message}
          </div>
        )}
      </div>
    </div>
  )
}

InputField.propTypes = {
  label: string,
  id: string,
  name: string.isRequired,
  showError: bool,
  errorText: string,
  type: string,
  required: bool,
  availabilityNotification: object,
  moreInfo: string,
  customClass: string,
}

export default InputField
